import { Grid, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import { truncateString } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';
import { SingleCardComponentProps } from '../../../pages/ExperiencePage';
import { transformCohortData } from '../../../core-utils/helper-utils/kpiPopupHelper';
import ArrowOutword from '../../atoms/Icons/ArrowOutword';
import { Arrow } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { getFormatterForTitle } from '../../../core-utils/helper-utils/experienceHelper';
import NoHistoricData from '../NoHistoryData';
import { useNavigate } from 'react-router-dom';

export interface CardComponentProps {
  visible: unknown;
  title: string;
  membersPer: string;
  populationPer: string;
  index: number;
  kpiUnit: string;
  toolTipData: string;
  redirecting: string;
}
export interface ClaimsAnalysisProps {
  egnid: string;
  incurredStartDate: any;
  incurredEndDate: any;
  paidStartDate: any;
  paidEndDate: any;
  isPlanDatesFetched: any;
  aggregationParameter: any;
}

const useStyles = makeStyles()({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  container1: {
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '8px',
    height: '319px',
  },
  containerNoData: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FAFAFC',
  },
  container1Center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '315px',
    width: '825px',
    padding: '10px',
  },
  noDataBottomCardContainer: {
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '8px',
    width: '100%',
    height: '160px',
    margin: '10px',
    backgroundColor: '#FAFAFC',
  },
  container2: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  defaultCard: {
    padding: '0px',
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    boxSizing: 'border-box',
    height: '106px',
    backgroundColor: '#fff',
  },
  borderItem: {
    borderRight: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    marginRight: '20px',
    height: '20px',
    alignSelf: 'center',
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: '12px 12px 18px 12px',
    height: '106px',
    boxSizing: 'border-box',
    gap: '18px',
  },
  simpleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // maxWidth: '264px',
    width: '100%',
    height: '150px',
    borderRadius: '8px',
    paddingTop: '8px',
    marginBottom: '12px',
    padding: '0px 2px',
  },
  kpiValueContainer: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '7px',
    width: '160px',
  },
  categoriesCardItem: {
    display: 'flex',
    padding: '8px 1px',
    gap: '4px',
    width: '100%',
  },
  categLabelSection: {
    display: 'flex',
    width: '80%',
    alignItems: 'center',
    gap: '4px',
  },
  loaderContainer: {
    height: '250px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cohortloaderContainer: {
    height: '160px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardRadius: {
    borderRadius: '4px',
  },
  noDataCard: {
    height: '120px',
    display: 'flex',
    justifyContent: 'center',
  },
  bottomCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 8px',
  },
  bottomCardTitle: {
    display: 'flex',
    gap: '3px',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  middleRowCard: {
    backgroundColor: '#F8F8FC',
  },
  text: {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    flexGrow: 1,
    cursor: 'pointer',
    color: patientAccessTheme.palette.text.mediumemphasis,
    textDecoration: 'underline dotted',
    textUnderlineOffset: '3px',
  },
});

export const CardComponent: React.FC<CardComponentProps> = ({
  title,
  membersPer,
  populationPer,
  kpiUnit,
  toolTipData,
  redirecting,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  return (
    <Grid className={classes.cardContainer}>
      {' '}
      <Grid style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
        <Tooltip
          disableFocusListener
          placement={'right-end'}
          title={<Typography fontSize="12px">{toolTipData}</Typography>}
          arrow={true}
        >
          <Grid
            onClick={() => {
              navigate(redirecting);
            }}
          >
            <Typography
              fontSize="12px"
              fontType="medium"
              cursor={redirecting ? 'pointer' : 'default'}
              styleProps={{
                display: 'inline', // key to keep everything inline
                color: patientAccessTheme.palette.text.mediumemphasis,
                wordBreak: 'break-word', // helps break long words
                lineHeight: '1.5',
                alignItems: 'center',
              }}
              textColor={`${patientAccessTheme.palette.text.mediumemphasis}`}
            >
              {truncateString(title, 70)}
              {redirecting && (
                <span
                  style={{
                    display: 'inline-block',
                    marginLeft: '4px',
                    verticalAlign: 'middle',
                  }}
                >
                  <ArrowOutword
                    fill={patientAccessTheme.palette.grey[500]}
                    cursor="pointer"
                  />
                </span>
              )}
            </Typography>
          </Grid>
        </Tooltip>
      </Grid>
      <Grid
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Grid className={classes.kpiValueContainer}>
          <Typography fontSize="16px" textColor="#000">
            {membersPer}
          </Typography>
          <Typography
            fontSize="11px"
            textColor={patientAccessTheme.palette.text.lowemphasis}
            // styleProps={{ width: '138px' }}
          >
            {kpiUnit}
          </Typography>
        </Grid>
        {populationPer !== '' && (
          <>
            <Grid
              className={classes.borderItem}
              style={{ width: 1, height: 24, margin: '0 12px' }}
            />
            <Typography
              fontSize="11px"
              textColor={patientAccessTheme.palette.text.lowemphasis}
              styleProps={{ width: '120px' }}
            >
              {populationPer}
            </Typography>
          </>
        )}
      </Grid>
    </Grid>
  );
};
export const SingleCardComponent: React.FC<SingleCardComponentProps> = ({
  title,
  items,
  backgroundColor = '#fff',
  subTitle,
  borderColor,
  rawCohortData,
  setIsKpiPopUp,
  onArrowClick,
  handleNavigate,
}) => {
  const { classes } = useStyles();
  const hasData = items && items.length > 0;
  const handleCardArrowClick = (title: string) => {
    const matched = rawCohortData?.find((section: any) => {
      const mapped = transformCohortData([section])[0];
      return mapped?.title === title;
    });
    setIsKpiPopUp(true);
    onArrowClick(matched);
  };

  return (
    <Grid
      className={classes.simpleContainer}
      style={{ backgroundColor, border: `1px solid ${borderColor || '#ccc'}` }}
    >
      <Grid className={classes.bottomCardHeader}>
        <Grid className={classes.bottomCardTitle}>
          <Typography
            component="span"
            fontSize="12px"
            textColor={patientAccessTheme.palette.text.highemphasis}
            fontType="medium"
          >
            {title}
          </Typography>
          <Typography
            fontSize="11px"
            textColor={patientAccessTheme.palette.text.lowemphasis}
            fontType="medium"
          >
            {subTitle ? `(${subTitle})` : ''}
          </Typography>
        </Grid>

        <ArrowOutword
          fill={patientAccessTheme.palette.grey[500]}
          cursor={'pointer'}
          onClick={() => handleCardArrowClick(title)}
        />
      </Grid>
      <Grid>
        {hasData ? (
          items
            ?.slice(0, 3)
            .map(
              (
                {
                  name,
                  value,
                  status,
                  claimlevellookups_key,
                  claimlevellookups_value,
                },
                index,
              ) => (
                <Grid key={index} className={classes.categoriesCardItem}>
                  <Grid className={classes.categLabelSection}>
                    <Grid
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: '20px',
                        height: '100%',
                      }}
                    >
                      {status !== '-' ? (
                        <Arrow
                          fill={status === 'low' ? 'green' : '#D6545E'}
                          style={{
                            transform:
                              status === 'low' ? 'rotate(180deg)' : 'none',
                            width: '20px',
                            height: '20px',
                          }}
                        />
                      ) : (
                        <Typography
                          fontSize="14px"
                          textColor={
                            patientAccessTheme.palette.text.mediumemphasis
                          }
                        >
                          -
                        </Typography>
                      )}
                    </Grid>
                    <Tooltip
                      disableFocusListener
                      placement={'top-start'}
                      title={<Typography fontSize="12px">{name}</Typography>}
                      arrow={true}
                    >
                      <Grid
                        style={{ width: '90%' }}
                        onClick={() => {
                          const matched = rawCohortData.find((section: any) => {
                            const mapped = transformCohortData([section])[0];
                            return mapped?.title === title;
                          });
                          handleNavigate(
                            claimlevellookups_key,
                            claimlevellookups_value,
                            matched.reference_date,
                            title,
                          );
                        }}
                      >
                        <Typography
                          fontSize="14px"
                          className={classes.text}
                          textColor={
                            patientAccessTheme.palette.text.mediumemphasis
                          }
                        >
                          {name}
                        </Typography>
                      </Grid>
                    </Tooltip>
                  </Grid>
                  <Typography
                    fontSize="14px"
                    fontType="medium"
                    styleProps={{ width: '10%' }}
                    textColor={patientAccessTheme.palette.text.highemphasis}
                  >
                    {getFormatterForTitle(title)(value)}
                  </Typography>
                </Grid>
              ),
            )
        ) : (
          <Grid className={classes.noDataCard}>
            <NoHistoricData title=" Historical data not available !" />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
